import settings from 'src/screens/account/settings';
export default settings;
